import styled from 'styled-components';

import { Button } from 'components/button';

export const DeleteFileButton = styled(Button)`
  margin-top: 16px;
`;
